<div class="stores">
    <div class="store-selection">
        <a class="link" [href]="'aimo.valioaimo.link.url' | cxTranslate">
            <i
                class="icon-inline aimo-icon icon-valioaimo icon-sm"
                placement="bottom"
                container="body"
                triggers="mouseenter:mouseleave"
                [ngbPopover]="'aimo.valioaimo.link.text' | cxTranslate"
                popoverClass="popover-md"></i>
            <span class="d-none d-md-inline-block d-lg-none d-xl-inline-block">{{
                'aimo.valioaimo.link.text' | cxTranslate
            }}</span>
        </a>
    </div>
    <div class="store-selection" [ngClass]="{ active: isPikatukku() }">
        <button class="link" (click)="gotoPikatukku()">
            <i
                class="icon-inline aimo-icon icon-storefront icon-sm"
                placement="bottom"
                container="body"
                triggers="mouseenter:mouseleave"
                [ngbPopover]="'aimo.store.pikatukku' | cxTranslate"
                popoverClass="popover-md"></i>
            <span class="d-none d-md-inline-block d-lg-none d-xl-inline-block">{{
                'aimo.store.pikatukku' | cxTranslate
            }}</span>
        </button>
        <div *ngIf="false" class="ml-2 d-inline-block circle circle-sm bg-red text-xsm text-bold"></div>
    </div>
    <div class="store-selection" [ngClass]="{ active: !isPikatukku() }">
        <button class="link" (click)="gotoToimitustukku()">
            <i
                class="icon-inline aimo-icon icon-truck icon-sm"
                placement="bottom"
                container="body"
                triggers="mouseenter:mouseleave"
                [ngbPopover]="'aimo.store.toimitustukku' | cxTranslate"
                popoverClass="popover-md"></i>
            <span class="d-none d-md-inline-block d-lg-none d-xl-inline-block">{{
                'aimo.store.toimitustukku' | cxTranslate
            }}</span>
        </button>
    </div>
    <div class="store-selection">
        <a class="link" [href]="'aimo.minunaimo.link.url' | cxTranslate">
            <i
                class="icon-inline aimo-icon icon-minunaimo icon-sm"
                placement="bottom"
                container="body"
                triggers="mouseenter:mouseleave"
                [ngbPopover]="'aimo.minunaimo.link.text' | cxTranslate"
                popoverClass="popover-md"></i>
            <span class="d-none d-md-inline-block d-lg-none d-xl-inline-block">{{
                'aimo.minunaimo.link.text' | cxTranslate
            }}</span>
        </a>
    </div>
    <div class="store-selection">
        <a class="link" [href]="'aimo.valo.link.url' | cxTranslate" target="_blank">
            <span class="d-none d-md-inline-block d-lg-none d-xl-inline-block align-middle">{{
                'aimo.valo.link.text' | cxTranslate
            }}</span>
            <i
                class="icon-inline aimo-icon icon-valo icon-sm ml-1"
                placement="bottom"
                container="body"
                triggers="mouseenter:mouseleave"
                [ngbPopover]="'aimo.valo.link.text' | cxTranslate"
                popoverClass="popover-md"></i>
        </a>
    </div>
</div>
